import fileDownload from 'js-file-download';
import api from '../api/Api';
import { ExportGraph, GraphData, TotalizerDashboardFilter, TotalizerItemResponse, TotalizerResponse } from './DashboardService';

/* mesmos contratos do DashboardService da NFe, apontando para /mdfe/dashboard */

/* no MDF-e o autorizado ainda esta em transito: os encerrados vem num totalizador proprio */
export interface MDFeTotalizerResponse extends TotalizerResponse {
  closed: TotalizerItemResponse;
}

export const findTotalByFilter = async (filter: TotalizerDashboardFilter): Promise<MDFeTotalizerResponse> => {
  return api.get<MDFeTotalizerResponse>('/mdfe/dashboard/total', { params: filter }).then(({ data }) => data);
}

export const exportGraph = async (requestData: ExportGraph) => {
  const res = await api.post('/mdfe/dashboard/graph/export', requestData, { responseType: 'blob' });
  fileDownload(res.data, res.headers.filename)
}

export const getCountGraphData = async (filter: TotalizerDashboardFilter): Promise<GraphData[]> => {
  return api.get<GraphData[]>('/mdfe/dashboard/count-grouped-by-period', { params: filter }).then(({ data }) => data);
}

export const getTotalAmountGraphData = async (filter: TotalizerDashboardFilter): Promise<GraphData[]> => {
  return api.get<GraphData[]>('/mdfe/dashboard/total-amount-grouped-by-period', { params: filter }).then(({ data }) => data);
}
